import React, {
    createContext,
    useContext,
} from 'react'

type AdminContextType = {
    // Add  properties here as needed
}

const AdminContext = createContext<AdminContextType | undefined>(undefined)

type AdminContextProps = {
    children: React.ReactNode | React.ReactNode[]
}

export const AdminContextProvider = ({
    children,
}: AdminContextProps): JSX.Element => {
    return (
        <AdminContext.Provider
            value={{
                // Add values here as needed
            }}
        >
            {children}
        </AdminContext.Provider>
    )
}

export const useAdmin = () => {
    const data = useContext(AdminContext)

    if (data === undefined) {
        throw new Error('useAdmin must used within AdminContextProvider')
    }

    return data
}
